import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import Input from '../../components/admin/Input';
import Button from '../../components/admin/Button';
import styles from './Login.module.css';
import { supabase } from '../../supabase';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      alert(error.message);
      return;
    }

    // 리다이렉트 경로가 있으면 해당 경로로, 없으면 기본 경로로 이동
    const redirectTo = location.state?.redirectTo || '/admin';
    navigate(redirectTo);
  };

  return (
    <div className={styles.loginContainer}>
      <form onSubmit={handleLogin} className={styles.loginForm}>
        <h1>관리자 로그인</h1>
        {error && <div className={styles.error}>{error}</div>}
        <div className={styles.inputContainer}>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="이메일"
            required
          />
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호"
            required
          />
        </div>
        <Button size="Medium" styleType="Primary" width="Full">로그인</Button>
      </form>
    </div>
  );
}

export default Login; 